module.exports = __webpack_public_path__ + "static/media/critical-thinking.3a0e4dfb.svg";